import { WIZARD_PROJECT_STAGES } from '../constants';
import { haptic } from '../../../utils/haptic';

const GRID_STYLE: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
};

const CARD_STYLE = (color: string, active: boolean): React.CSSProperties => ({
  padding: '10px 12px',
  borderRadius: 8,
  border: `1px solid ${active ? color : 'rgba(255,255,255,0.07)'}`,
  background: active ? `rgba(${hexToRgb(color)}, 0.08)` : 'rgba(255,255,255,0.04)',
  color: '#f4f0ff',
  fontSize: '0.8125rem',
  fontWeight: 500,
  cursor: 'pointer',
  textAlign: 'left' as const,
  transition: 'border-color 0.2s, background 0.2s',
});

function hexToRgb(hex: string): string {
  if (hex.startsWith('var(')) return '120, 80, 255';
  const m = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!m) return '120, 80, 255';
  return `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}`;
}

export function ProjectStageSelector({
  selected,
  onChange,
}: {
  selected: string;
  onChange: (projectStatus: string) => void;
}) {
  return (
    <div style={GRID_STYLE}>
      {WIZARD_PROJECT_STAGES.map((stage) => {
        const active = selected === stage.value;
        return (
          <button
            key={stage.value}
            type="button"
            style={CARD_STYLE(stage.color, active)}
            onClick={() => {
              haptic.select();
              onChange(stage.value);
            }}
            aria-pressed={active}
          >
            {stage.label}
          </button>
        );
      })}
    </div>
  );
}
